var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "MagnifyingGlass",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-magnifying-glass","viewBox":"0 0 518 518"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M494.2 470.1l-158-160.6c25.1-32.4 40.1-73.2 40.1-117.7C376.4 86.4 292.3 1 188.7 1 85 1 .9 86.4.9 191.8s84 190.8 187.7 190.8c47.9 0 91.5-18.4 124.7-48.4L470.6 494c6.5 6.6 17.1 6.6 23.6 0s6.5-17.3 0-23.9zM188.8 348.8c-88.7 0-156.4-68.4-156.4-158s67.7-158 156.4-158 156.4 68.5 156.4 158-67.7 158-156.4 158z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/magnifying-glass.svg